import React, { useState } from 'react';

const PointOfSaleMapTeaser = ({ location }) => {
    const [open, setOpen] = useState(false);

    const toggleOpen = () => { setOpen(!open); };

    return (
        <div className="point-of-sale-map-teaser">
            <button className="point-of-sale-map-teaser__toggle" onClick={toggleOpen}>
                <svg viewBox="0 0 48 48">
                    <path d="M24,1C15.2,1,6.015,7.988,6,18C5.982,29.981,24,48,24,48s18.019-17.994,18-30 C41.984,8.003,32.8,1,24,1z M24,26c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S28.418,26,24,26z" />
                </svg>
            </button>
            {open && (
                <a className="point-of-sale-map-teaser__content" href={location.url}>
                    {location.title}
                </a>
            )}
        </div>
    );
};

export { PointOfSaleMapTeaser };
